import { render, staticRenderFns } from "./CompleteResetPassword.vue?vue&type=template&id=47400be0"
import script from "./CompleteResetPassword.vue?vue&type=script&lang=ts"
export * from "./CompleteResetPassword.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports